import './PersonalizeItemCard.css'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { Popover } from '@mui/material'
import { useEffect, useState } from 'react'
import RiskScore from 'src/components/Individual/RiskScore'
import { addScroll, removeScroll } from 'src/utils/commonMethods'
import { PERSONALIZE_LIST_TYPE } from 'src/utils/constants/PersonaliseDashboard'
import ReferClaim from 'src/components/Individual/Personalize/Components/ReferClaim/ReferClaim'
import ViewHNIReport from 'src/components/Individual/Personalize/ViewHNIReport'
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined'
import { REPORT_DOWNLOAD } from 'src/utils/constants/Individual'

const PersonalizeItemCard = ({ itemDetails, reportData }) => {
  const [popOverElement, setPopOverElement] = useState(null)

  const handlePopOverOpen = (event) => {
    setPopOverElement(event?.currentTarget)
  }

  const handlePopOverClose = () => {
    setPopOverElement(null)
  }

  const isPopOverOpen = Boolean(popOverElement)

  useEffect(() => {
    if (isPopOverOpen) {
      removeScroll()
    } else {
      addScroll()
    }

    return () => {
      addScroll()
    }
  }, [isPopOverOpen])

  const getPopoverComponent = () => {
    switch (itemDetails.type) {
      case PERSONALIZE_LIST_TYPE?.referClaim:
        return <ReferClaim />
      case PERSONALIZE_LIST_TYPE?.riskScore:
        return <RiskScore />
      case PERSONALIZE_LIST_TYPE?.garage:
        return <>Garage</>
      case PERSONALIZE_LIST_TYPE?.lifeEvents:
        return <>Life Events</>
      case PERSONALIZE_LIST_TYPE?.reportDownload:
        return (
          <>
            <ViewHNIReport reportData={reportData} />
          </>
        )

      default:
        return <></>
    }
  }

  return (
    <>
      <Popover
        id='personalize-item-popover'
        open={isPopOverOpen}
        anchorEl={popOverElement}
        onClose={handlePopOverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div className={'popover-component-container'}>
          <div className={'popover-component'}>{getPopoverComponent()}</div>
        </div>
      </Popover>
      <div className='personalize-card-container' onClick={handlePopOverOpen}>
        {itemDetails?.type === REPORT_DOWNLOAD && (
          <NotificationsActiveOutlinedIcon
            className='notifications-active-icon'
            fontSize='large'
          />
        )}
        <img
          src={itemDetails?.logo}
          className={'personalize-card-logo'}
          alt='Logo'
        />
        <div className={'personalize-card-details'}>
          <span className={'personalize-card-title'}>{itemDetails?.label}</span>
          <span className={'personalize-card-description'}>
            {itemDetails?.description}
          </span>
        </div>
        <KeyboardArrowDownIcon className={'personalize-card-dropdown'} />
      </div>
    </>
  )
}

export default PersonalizeItemCard
